module.exports = __webpack_public_path__ + "img/email.b8a93c8f.svg";